export const dateTimeFormats = {
	short: {
		month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
	},
	medium: {
		year: 'numeric', month: 'short', day: 'numeric'
	},
	long: {
		year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
	},
	full: {
		year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'
	}
};
export const messages = {
    "login.form.title": "登录",
    "login.form.hint.user": "登录名",
    "login.form.hint.password": "密码",
    "login.form.checkbox.remember-me": "记住我",
    "login.form.button.sign-in": "登录",
    "login.form.message.invalid-user-credentials": "登录名或密码不正确",
    "login.form.message.account-temporarily-locked": "您的帐户已暂时锁定，请在 5 分钟后返回",
    "login.form.message.user-required": "输入登录名",
    "login.form.message.password-required": "输入密码",
    "login.form.button.forgot-password": "忘记密码？",
    "error.mfa-required.title": "设置双重身份验证",
    "error.mfa-required.message1": "需要双重身份验证来保护您的帐户。",
    "error.mfa-required.message2": "您将被重定向到在线仪表板中的帐户设置。启用双重身份验证，按照设置说明操作，然后返回此处。",
    "error.mfa-required.learnMore": "了解有关双重身份验证的详细信息",
    "error.mfa-required.continue": "继续",
    "error.root-admin-login.title": "Error 403 – 已禁止",
    "error.root-admin-login.message": "您已作为只读管理员登录。访问 Web Recovery 中控台，请以客户租户或管理员身份登录",
    "error.server-busy.message": "服务器繁忙，请稍后再试。",
    "error.network-connection.title": "网络连接错误",
    "error.network-connection.message": "检查 Internet 连接并重试。",
    "error.internal-server-error.title": "内部服务器错误",
    "error.internal-server-error.message": "要解决错误，请联系支持人员并提供错误详细信息:",
    "error.internal-server-error.copy.button": "复制"
};
